import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { MessageOutlined, Phone } from '@mui/icons-material';
import { useState } from 'react';

const TextOrCall = ({
  inverted = false,
  fixed = false,
}: {
  inverted?: boolean;
  fixed?: boolean;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const buttonStyles = {
    backgroundColor: inverted ? 'white' : 'primary.main',
    color: inverted ? 'primary.main' : 'white',
    borderRadius: '1.25em',
    padding: { xs: '0.4em 1.2em', sm: '0.5em 1.5em', md: '0.6em 1.75em' },
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    border: inverted ? '1px solid' : 'none',
    borderColor: 'primary.main',
    fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' },
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: 'fit-content',
    mx: fixed ? 0 : 'auto',
    ...(fixed && {
      position: 'fixed',
      bottom: 20,
      left: 20,
      zIndex: 1000,
    }),
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
    },
  };

  return (
    <>
      {/* Single Contact Us Button */}
      <Box onClick={() => setDialogOpen(true)} sx={buttonStyles}>
        <Phone
          sx={{ fontSize: '1.4em', color: inverted ? 'primary.main' : 'white' }}
        />
        <Typography
          fontSize="inherit"
          fontWeight={600}
          color={inverted ? 'primary.main' : 'white'}
        >
          Contact Us
        </Typography>
      </Box>

      {/* Dialog with Call/Text Options */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>How would you like to reach us?</DialogTitle>
        <DialogContent>
          <Typography variant="body2" mb={2}>
            Whether you prefer texting or calling, we&apos;re here to help!
          </Typography>
          <Stack spacing={2} py={1}>
            <Button
              variant="contained"
              href="tel:+12059730007"
              startIcon={<Phone />}
              fullWidth
            >
              Call (205) 973-0007
            </Button>
            <Button
              variant="contained"
              href="sms:+12059730007"
              startIcon={<MessageOutlined />}
              fullWidth
            >
              Text (205) 973-0007
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TextOrCall;
